import { Fragment, useContext, useEffect, useState } from "react";
import ExportCSVButton from "../../../Components/ExportCSVButton";
import ClearFilterButton from "../../../Components/ClearFilterButton";
import { useLocation, useNavigate } from "react-router-dom";
import SampleRequestListTable from "./SampleTypeListTable";
import DateRangeDropdown from "../../../Components/AdministrativeSettings/DateRangeDropdown";
import Toaster from "../../../Components/Toaster";
import { Helmet } from "react-helmet";
import TokenService from "../../../Services/Token.service";

function SampleRequests({ selectedRange, setSelectedRange, type, openRequestsFilter,appointmentsFilter, setOpenRequestsFilter,setAppointmentsFilter }) {

    const userRestrictions = TokenService.getUserRestrictions() || [];
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');
    
    const navigate = useNavigate();
    const [isClearFilter, setIsClearFilter] = useState(false);
    const [filterCount, setFilterCount] = useState(0);
    const [exportCsv, setexportCsv] = useState(false);
    const handleClearFilters = () => {
        setIsClearFilter(true);
        setOpenRequestsFilter([]);
        setAppointmentsFilter([null,null]);
        setTimeout(() => setIsClearFilter(false), 0);
    };

    const handleFilterCountChange = (count) => {
        setFilterCount(count); // Update filter count
    };

    const handleExportCSV = () => {
       
        setexportCsv(true);
        setTimeout(() => setexportCsv(false), 0);
    } 

    const handleDateRangeChange = (eventKey) => {
        setSelectedRange(eventKey);
    };

    const location = useLocation();
    useEffect(() => { 
        if (location.state?.toastMessage) {
                setShowToast(true);
                setToastMessage(location.state.toastMessage);
                setToastVariant(location.state.toastVariant);
            // showToast(location.state.toastMessage, location.state.toastVariant);

             // Clear location.state to prevent the toast from triggering on refresh
            navigate(location.pathname, { replace: true }); 

             // Clear toast state after displaying
             return () => {
                setShowToast(false);
                setToastMessage(null);
                setToastVariant(null);
            };
        }
    },[], [location.state, showToast, navigate]);

    return (
 
        <Fragment>
            <Helmet>
                <title>DonorX | Sample Request</title>
            </Helmet>
            <div className=" ">
                <div className="el-bg-table">
                    <div className="d-flex justify-content-between">
                        <div className="d-flex justify-content-between align-items-center" >
                            {/* style={{ width: "45%" }} */}
                            <div  className="d-flex justify-content-between align-items-center" style={{ marginRight: '15px' }}>
                                <h3>Sample Requests
                                </h3>
                                {!userRestrictions.includes('request-new-sample') && (
                                    <>
                                        {type === 'requestor' && (<button onClick={()=>navigate('/requestor/request-new-sample')} className="el-main-button ms-3"><span><i className="el-icon-add"></i>New Request</span></button>)}
                                    </>
                                )}                                
                            </div>

                            {type != 'requestor' && (<ExportCSVButton handleExportCSV={handleExportCSV} />)}
                            {filterCount > 0 && (<ClearFilterButton handleClearFilters={handleClearFilters} />)}
                            {filterCount > 0 && (<span className="m-2">Filters applied: {filterCount}</span>)}
                        </div>
                        
                        <DateRangeDropdown
                            selectedRange={selectedRange}
                            handleDateRangeChange={handleDateRangeChange}
                        />
                    </div>
                    <>
                        <SampleRequestListTable isClearFilter={isClearFilter} selectedRange={selectedRange} onFilterCountChange={handleFilterCountChange} exportCsv={exportCsv} type={type} openRequestsFilter={openRequestsFilter} appointmentsFilter={appointmentsFilter} />
                    </>
                </div>
            </div>
            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
        </Fragment>
    );
}


export default SampleRequests